import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Typography, IconButton, TextField, FormControl, Dialog, Divider, Switch, FormControlLabel
} from '@mui/material';
import { withRouter } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close';
import * as actions from "../../../../store/actions";
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle
} from '../../../../containers/Admin/Forms/styles';
import Spinner from '../../../../components/Spinner/index';
import { isEmpty } from 'lodash';

const ModalSites = (props) => {
  const dispatch = useDispatch();

  const orderBy = "name";
  const order = "asc";

  const [siteName, setSiteName] = useState("");
  const [sitesFormated, setSitesFormated] = useState([]);
  const [copySiteQuestions, setCopySiteQuestions] = useState(false);
  const [selectedSite, setSelectedSite] = useState(null);
  const [searchTextSites, setSearchTextSites] = useState('');
  const [siteError, setSiteError] = useState(false);
  const [siteNameError, setSiteNameError] = useState(false);

  const fetchSites = useCallback(
    () => dispatch(actions.fetchSitesForModalByTenant(props.tenantId, 1, 30, searchTextSites, order, orderBy)),
    [searchTextSites, order, orderBy]
  );

  const sites = useSelector(state => state.tenants.sitesForModals);
  const loadingSites = useSelector(state => state.tenants.loadingSites);

  useEffect(() => {
    setSitesFormated(sites.rows.map(dt => ({ value: dt._id, label: dt.name })))
  }, [sites])

  useEffect(() => {
    fetchSites();
  }, [searchTextSites]);

  const handleSubmit = async e => {
    e.stopPropagation();
    e.preventDefault();

    let hasError = false;

    if (siteName === '') {
      hasError = true;
      setSiteNameError(true);
    }

    if (copySiteQuestions && !selectedSite) {
      hasError = true;
      setSiteError(true);
    }

    if (hasError) return

    const body = {
      name: siteName,
      copyChecklist: copySiteQuestions,
      copiedSiteId: copySiteQuestions ? selectedSite.value : null,
    };

    props.postSites(body);
    props.onClose();
    setSiteName('');
    setCopySiteQuestions(false);
    setSelectedSite(null);
  }

  const handleInputChangeSelectorSites = (text) => {
    setSearchTextSites(text);
  }

  const handleInputChangeSites = (selected) => {
    setSiteError(false);
    setSelectedSite(selected)
  }

  return (
    <Dialog
      maxWidth='sm'
      fullWidth
      scroll='body'
      open={props.open}
      onClose={() => props.onClose()}
    >
      <FormStyled onSubmit={handleSubmit} style={{ ...styles.opacityContainer, opacity: loadingSites ? '0.3' : '1' }}>
        {loadingSites && <Spinner overlay />}
        <DivFormTitle>
           <Typography variant='h6'>Adicionar Novo Site</Typography>
        </DivFormTitle>
        <Divider />
        <FormControl variant="standard" fullWidth margin='normal' required>
          <TextField
            variant="standard"
            label='Nome do Site'
            name='siteName'
            onChange={event => { setSiteName(event.target.value); setSiteNameError(false) }}
            value={siteName}
            margin='normal'
            error={siteNameError}
            disabled={false} />
        </FormControl>
        <FormControlLabel
          control={
            <Switch
              checked={copySiteQuestions}
              onChange={(event) => setCopySiteQuestions(event.target.checked)}
            />
          }
          label={'Copiar Checklist de outro Site'}
        />

        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingSites} //sent to isLoading
            label='Selecione o Site que deseja copiar a Checklist'
            data={sitesFormated} // sent to options
            onSelectValue={handleInputChangeSites} // sent to onChange
            valueSelected={selectedSite} // sent to value
            newSearchText={handleInputChangeSelectorSites}
            name='site'
            hasError={siteError}
            disabled={!copySiteQuestions}
          />
        </FormControl>
        <DivSubmitButtons>
          <IconButton onClick={() => props.onClose()} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
          <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
        </DivSubmitButtons>
      </FormStyled>
    </Dialog>
  );
}

export default withRouter(ModalSites);

const styles = {
  opacityContainer: {
    position: 'relative'
  },
}
